import ActionTypes from '../../../ActionsTypes';
export function add(input) {
  return {
    type: ActionTypes.ADD_TO_CART,
    payload: {
      input: input
    }
  };
}
export function remove(key, rate) {
  return {
    type: ActionTypes.REMOVE_FROM_CART,
    payload: {
      key: key,
      rate: rate
    }
  };
}